export default __webpack_public_path__ + "static/media/banner-finance-comp.a874fa43.jpg";